// src/i18n/es/index.js

// Importar traducciones modulares con fix
const zones = require('./zones').zones || {};
const tagTypes = require('./tagTypes').tagTypes || {};
const lockerTypes = require('./lockerTypes').default || {};
const hotels = require('./hotels').default || {};
const groups = require('./groups').default || {};
const hmis = require('./hmis').default || {};
const lockerControllers = require('./lockerControllers').default || {};
const lockers = require('./lockers').default || {};
const lockerAssignments = require('./lockerAssignments').lockerAssignments || {};
const common = require('./common').default || {};
const dashboard = require('./dashboard').default || {};
const users = require('./users').default || {};
const auth = require('./auth').default || {};
const tags = require('./tags').default || {};
const hmiSimulator = require('./hmiSimulator').default || {};

const es = {
  ra: {
    action: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      search: 'Buscar',
      refresh: 'Actualizar',
      export: 'Exportar',
      list: 'Listar',
      show: 'Ver',
      menu: 'Menú',
      back: 'Volver',
      add_filter: 'Añadir filtro',
      confirm: 'Confirmar',
      more: 'Más opciones',
      clear_input_value: 'Limpiar campo',
      close: 'Cerrar',
      add: 'Añadir',
      sort: 'Ordenar',
      none: 'Ninguno'
    },
    validation: {
      required: 'Este campo es obligatorio',
    },
    navigation: {
      no_results: 'No se encontraron resultados',
      loading: 'Cargando',
      page_rows_per_page: 'Filas por página:',
      page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
      page_out_of_boundaries: 'Página %{page} fuera de límites',
      page_out_from_end: 'No se puede ir más allá de la última página',
      page_out_from_begin: 'No se puede ir antes de la página 1',
      page_empty: 'Sin registros',
      next: 'Siguiente',
      prev: 'Anterior',
      page_info: '%{from}-%{to} de %{count}',
      page_rows_per_page_all: 'Todas',
      // Claves adicionales que React Admin v5 podría usar
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} de %{total}',
      page_range: '%{from}-%{to} de %{count}',
      displayed_records: '%{from}-%{to} of %{count}',
    },
    pagination: {
      page_info: '%{from}-%{to} de %{count}',
      page_info_simple: 'Página %{page}',
      labeled_page_info: '%{from}-%{to} de %{count}',
    },
    page: {
      not_found: 'Página no encontrada',
      dashboard: 'Panel de Control',
      list: 'Lista',
      create: 'Crear',
      edit: 'Editar',
    },
    message: {
      not_found: 'El recurso solicitado no fue encontrado',
      delete_title: 'Confirmar eliminación',
      delete_content: '¿Está seguro de que desea eliminar este elemento?',
      invalid_form: 'El formulario contiene errores. Por favor, revise los campos',
    },
    notification: {
      deleted: 'Elemento eliminado',
    },
    auth: {
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      username: 'Usuario',
      password: 'Contraseña',
      logging_in: 'Iniciando sesión...',
      sign_in_error: 'Error al iniciar sesión. Verifique sus credenciales.',
    },
    configurable: {
      customize: 'Personalizar',
    },
  },
  fields: {
    hotel: 'Hotel',
    zone: 'Zona',
    name: 'Nombre',
    description: 'Descripción',
    status: 'Estado',
    active: 'Activo',
    type: 'Tipo',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    address: 'Dirección',
    city: 'Ciudad',
    country: 'País',
    createdAt: 'Fecha de creación',
    updatedAt: 'Última actualización',
    lastSeenAt: 'Última conexión',
    isOnline: 'En línea',
  },
  common,
  resources: {
    lockers,
    locker_assignments: lockerAssignments,
    users: users,
    hotels: hotels,
    groups: groups,
    tags: tags,
    settings: {
      name: 'Configuración |||| Configuraciones',
    },
    tag_types: {
      name: 'Tipo de ID |||| Tipos de IDs',
    },
    locker_controllers: lockerControllers,
    hmis,
    locker_types: {
      name: 'Tipo de Taquilla |||| Tipos de Taquillas',
    },
    hmi_simulator: {
      name: 'Simulador |||| Simuladores',
    },
    // Versiones con guiones para compatibilidad con React Admin
    'tag-types': tagTypes,
    'locker-controllers': lockerControllers,
    'locker-types': lockerTypes,
    'locker-assignments': lockerAssignments,
    'hmi-simulator': {
      name: 'Simulador |||| Simuladores',
    },
    zones: zones,
    tagTypes: tagTypes,
    dashboard: dashboard,
  },
  dashboard,
  users,
  auth,
  hmiSimulator,
  user: {
    profile: 'Perfil',
    settings: 'Configuración',
    change_password: 'Cambiar contraseña',
  },
  pages: {
    login: {
      subtitle: 'Inicie sesión para comenzar',
      login_button: 'Iniciar Sesión',
    },
    dashboard: {
      no_devices: 'No se han encontrado resultados',
      no_devices_description: 'No hay datos disponibles en este momento',
    },
  },
};

export default es;